import { render, staticRenderFns } from "./PendingResponseModal.vue?vue&type=template&id=4894b93e&scoped=true&"
import script from "./PendingResponseModal.vue?vue&type=script&lang=js&"
export * from "./PendingResponseModal.vue?vue&type=script&lang=js&"
import style0 from "./PendingResponseModal.vue?vue&type=style&index=0&id=4894b93e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4894b93e",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox, CDivider: require('@chakra-ui/vue').CDivider, CFlex: require('@chakra-ui/vue').CFlex})
